import InvoiceBatchItem from "../../entities/invoiceBatchItem";

/**
 * InvoiceBatchItem actions
 *
 * Call order:
 *
 * INVOICEBATCHITEM_SAVE_QUEUE:	adds the item to the save queue
 * --> INVOICEBATCHITEM_SAVE:	modifies the state
 * --> INVOICEBATCHITEM_SAVE_SUCCESS: if all went well
 * --> INVOICEBATCHITEM_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail INVOICEBATCHITEM_SAVE_QUEUE is during the call to INVOICEBATCHITEM_SAVE,
 * as adding an item to the queue should never fail.
 */

export const INVOICEBATCHITEM_FETCH_ONE_QUEUE: any = 'INVOICEBATCHITEM_FETCH_ONE_QUEUE';
export const INVOICEBATCHITEM_FETCH_SUCCESS: any = 'INVOICEBATCHITEM_FETCH_SUCCESS';
export const INVOICEBATCHITEM_FETCH_FAILURE: any = 'INVOICEBATCHITEM_FETCH_FAILURE';
export const INVOICEBATCHITEM_FETCH_ONE_SUCCESS: any = 'INVOICEBATCHITEM_FETCH_ONE_SUCCESS';
export const INVOICEBATCHITEM_FETCH_ONE_FAILURE: any = 'INVOICEBATCHITEM_FETCH_ONE_FAILURE';

export const INVOICEBATCHITEM_SAVE: any = 'INVOICEBATCHITEM_SAVE';
export const INVOICEBATCHITEM_SAVE_QUEUE: any = 'INVOICEBATCHITEM_SAVE_QUEUE';
export const INVOICEBATCHITEM_SAVE_SUCCESS: any = 'INVOICEBATCHITEM_SAVE_SUCCESS';
export const INVOICEBATCHITEM_SAVE_FAILURE: any = 'INVOICEBATCHITEM_SAVE_FAILURE';

export const INVOICEBATCHITEM_SAVE_MANY: any = 'INVOICEBATCHITEM_SAVE_MANY';
export const INVOICEBATCHITEM_SAVE_MANY_QUEUE: any = 'INVOICEBATCHITEM_SAVE_MANY_QUEUE';
export const INVOICEBATCHITEM_SAVE_MANY_SUCCESS: any = 'INVOICEBATCHITEM_SAVE_MANY_SUCCESS';
export const INVOICEBATCHITEM_SAVE_MANY_FAILURE: any = 'INVOICEBATCHITEM_SAVE_MANY_FAILURE';

export const INVOICEBATCHITEM_REMOVE: any = 'INVOICEBATCHITEM_REMOVE';
export const INVOICEBATCHITEM_REMOVE_QUEUE: any = 'INVOICEBATCHITEM_REMOVE_QUEUE';
export const INVOICEBATCHITEM_REMOVE_SUCCESS: any = 'INVOICEBATCHITEM_REMOVE_SUCCESS';
export const INVOICEBATCHITEM_REMOVE_FAILURE: any = 'INVOICEBATCHITEM_REMOVE_FAILURE';

export const INVOICEBATCHITEM_RESTORE: any = 'INVOICEBATCHITEM_RESTORE';
export const INVOICEBATCHITEM_RESTORE_QUEUE: any = 'INVOICEBATCHITEM_RESTORE_QUEUE';
export const INVOICEBATCHITEM_RESTORE_SUCCESS: any = 'INVOICEBATCHITEM_RESTORE_SUCCESS';
export const INVOICEBATCHITEM_RESTORE_FAILURE: any = 'INVOICEBATCHITEM_RESTORE_FAILURE';

export const INVOICEBATCHITEM_RESTORE_MANY: any = 'INVOICEBATCHITEM_RESTORE_MANY';
export const INVOICEBATCHITEM_REMOVE_MANY: any = 'INVOICEBATCHITEM_REMOVE_MANY';

/* Fetch actions */
export const fetchInvoiceBatchItemSuccess = (invoiceBatchItems: InvoiceBatchItem[], partial: boolean, lastFetch: number) => ({type: INVOICEBATCHITEM_FETCH_SUCCESS, invoiceBatchItems, partial, lastFetch});
export const fetchInvoiceBatchItemFailure = (err: any) => {
		console.error('InvoiceBatchItemAction: fetchInvoiceBatchItemFailure', err);
		return {type: INVOICEBATCHITEM_FETCH_FAILURE, err};
};
export const fetchOneInvoiceBatchItemQueue = (invoiceBatchItemId: string) => ({type: INVOICEBATCHITEM_FETCH_ONE_QUEUE, invoiceBatchItemId});
export const fetchOneInvoiceBatchItemSuccess = (invoiceBatchItem: InvoiceBatchItem) => ({type: INVOICEBATCHITEM_FETCH_ONE_SUCCESS, invoiceBatchItem});
export const fetchOneInvoiceBatchItemFailure = (id: string, err: any) => {
		console.error('InvoiceBatchItemAction: fetchOneInvoiceBatchItemFailure', err);
		return {type: INVOICEBATCHITEM_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveInvoiceBatchItem = (invoiceBatchItem: InvoiceBatchItem) => {
    // console.debug('⮂ INVOICEBATCHITEM_SAVE action', invoiceBatchItem?.id);
    return {type: INVOICEBATCHITEM_SAVE, invoiceBatchItem};
}
export const saveInvoiceBatchItemQueue = (invoiceBatchItem: InvoiceBatchItem, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ INVOICEBATCHITEM_SAVE_QUEUE action', invoiceBatchItem?.id);
    return {type: INVOICEBATCHITEM_SAVE_QUEUE, invoiceBatchItem, onQueued};
}
export const saveInvoiceBatchItemSuccess = (invoiceBatchItem: InvoiceBatchItem) => {
    // console.debug('⮂ INVOICEBATCHITEM_SAVE_SUCCESS action', invoiceBatchItem?.id);
    return {type: INVOICEBATCHITEM_SAVE_SUCCESS, invoiceBatchItem};
}
export const saveInvoiceBatchItemFailure = (invoiceBatchItem: InvoiceBatchItem, status: number, message: string) => {
    console.warn(`⮂ INVOICEBATCHITEM_SAVE_FAILURE error saving invoiceBatchItem: HTTP ${status}: ${message}`, invoiceBatchItem?.id);
    return {type: INVOICEBATCHITEM_SAVE_FAILURE, invoiceBatchItem, status, message};
};

/* SaveMany actions */
export const saveManyInvoiceBatchItems = (invoiceBatchItems: InvoiceBatchItem[]) => {
    // console.debug('⮂ INVOICEBATCHITEM_SAVE_MANY action', invoiceBatchItems?.map(invoiceBatchItem => invoiceBatchItem?.id).join(','));
    return {type: INVOICEBATCHITEM_SAVE_MANY, invoiceBatchItems};
}
export const saveManyInvoiceBatchItemsQueue = (invoiceBatchItems: InvoiceBatchItem[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ INVOICEBATCHITEM_SAVE_MANY_QUEUE action', invoiceBatchItems?.map(invoiceBatchItem => invoiceBatchItem.id).join(','));
    return {type: INVOICEBATCHITEM_SAVE_MANY_QUEUE, invoiceBatchItems, onQueued};
}

export const saveManyInvoiceBatchItemsSuccess = (invoiceBatchItems: InvoiceBatchItem[]) => {
    // console.debug('⮂ INVOICEBATCHITEM_SAVE_MANY_SUCCESS action', invoiceBatchItems?.map(invoiceBatchItem => invoiceBatchItem.id).join(','));
    return {type: INVOICEBATCHITEM_SAVE_MANY_SUCCESS, invoiceBatchItems};
}
export const saveManyInvoiceBatchItemsFailure = (invoiceBatchItems: InvoiceBatchItem[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_INVOICEBATCHITEMS_FAILURE Error saving invoiceBatchItems: HTTP ${status}: ${message}`, invoiceBatchItems?.map(invoiceBatchItem => invoiceBatchItem.id).join(','));
		return {type: INVOICEBATCHITEM_SAVE_MANY_FAILURE, invoiceBatchItems, status, message};
};

/* Remove actions */
export const removeInvoiceBatchItem = (invoiceBatchItem: InvoiceBatchItem) => ({ type: INVOICEBATCHITEM_REMOVE, invoiceBatchItem });
export const removeInvoiceBatchItemQueue = (invoiceBatchItem: InvoiceBatchItem) => ({ type: INVOICEBATCHITEM_REMOVE_QUEUE, invoiceBatchItem });
export const removeInvoiceBatchItemSuccess = (invoiceBatchItem: InvoiceBatchItem) => ({ type: INVOICEBATCHITEM_REMOVE_SUCCESS, invoiceBatchItem });
export const removeInvoiceBatchItemFailure = (invoiceBatchItem: InvoiceBatchItem, status: number, message: string) => {
	console.error(`Redux: removeInvoiceBatchItemFailure Error removing invoiceBatchItem: HTTP ${status}: ${message}`);
	return ({ type: INVOICEBATCHITEM_REMOVE_FAILURE, invoiceBatchItem, status, message });
};

/* Restore actions */
export const restoreInvoiceBatchItem = (invoiceBatchItem: InvoiceBatchItem) => ({ type: INVOICEBATCHITEM_RESTORE, invoiceBatchItem });
export const restoreInvoiceBatchItemQueue = (invoiceBatchItem: InvoiceBatchItem) => ({ type: INVOICEBATCHITEM_RESTORE_QUEUE, invoiceBatchItem });
export const restoreInvoiceBatchItemSuccess = (invoiceBatchItem: InvoiceBatchItem) => ({ type: INVOICEBATCHITEM_RESTORE_SUCCESS, invoiceBatchItem });
export const restoreInvoiceBatchItemFailure = (invoiceBatchItem: InvoiceBatchItem, status: number, message: string) => {
	console.error(`Redux: restoreInvoiceBatchItemFailure Error restoring invoiceBatchItem: HTTP ${status}: ${message}`);
	return ({ type: INVOICEBATCHITEM_RESTORE_FAILURE, invoiceBatchItem, status, message });
};

/* RestoreMany actions */
export const restoreManyInvoiceBatchItems = (invoiceBatchItems: InvoiceBatchItem[]) => ({ type: INVOICEBATCHITEM_RESTORE_MANY, invoiceBatchItems });

/* RemoveMany actions */
export const removeManyInvoiceBatchItems = (invoiceBatchItems: InvoiceBatchItem[]) => ({ type: INVOICEBATCHITEM_REMOVE_MANY, invoiceBatchItems });